import React, { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2'

import { AppContext } from "../../../services/AppContext";
import AuthContext from '../../../context/auth-context';

import { MdEdit, MdErrorOutline, MdSave, MdCheck } from "react-icons/md";

import useInput from '../../../hooks/useInput';
import useFileInput from '../../../hooks/useFileInput';
import useGetPaises from '../../../hooks/useGetPaises'
import useGetExperienciaLaboral from '../../../hooks/useGetExperienciaLaboral';

import Card from '../../UI/Card';

const ExperienciaLaboral = (props) => {
    const { setAppValues } = useContext(AppContext);
    const authContext = useContext(AuthContext);

    const[block, setBlock] = useState(false);
    const [error, setError] = useState(false);

    const paises = useGetPaises();
    const laboralData = useGetExperienciaLaboral(authContext.token);

    useEffect(() => {

        if(laboralData.LOADING){
            Swal.fire({
                title: `Loading...
                    <div class="spinner-border text-primary mt-4" role="status" />
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            return;
        }
        Swal.close();

        if(laboralData.STATUS && laboralData.STATUS === "SUCCESS"){
            setError(false);

        } else if(laboralData.STATUS && laboralData.STATUS === "ERROR"){
            setError(true);

            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: laboralData.ERROR.MESSAGE,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        } else {
            setError(true);
            
            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: 'Ocurrió un problema, intentelo más tarde',
                showConfirmButton: false,
            });
        }

    }, [laboralData]);

    // ------------------------------------------------------------------------
    // ------------------------------------------------------------------------

    // INPUT EMPRESA
    const empresaValidacion = value => value.trim() !== "";
    const {
        value: empresa,
        isValid: empresaIsValid,
        isTouched: empresaIsTouched,
        userChange: empresaUserChange,
        divInput: divEmpresa,
        valueChangeHandler: empresaChangeHanlder,
        inputBlurHandler: empresaBlurHandler,
        resetInput: resetInputEmpresa,
        scrollToDiv: scrollToDivEmpresa,
        setInputValue: setEmpresaValue
    } = useInput(empresaValidacion);

    useEffect(() => {
        if(!!laboralData.empresa && !empresaUserChange){
            setEmpresaValue(laboralData.empresa);
        }
    }, [laboralData.empresa, empresaUserChange, setEmpresaValue]);

    // INPUT DIRECCION
    const direccionValidacion = value => value.trim() !== "";
    const {
        value: direccion,
        isValid: direccionIsValid,
        isTouched: direccionIsTouched,
        userChange: direccionUserChange,
        divInput: divDireccion,
        valueChangeHandler: direccionChangeHanlder,
        inputBlurHandler: direccionBlurHandler,
        resetInput: resetInputDireccion,
        scrollToDiv: scrollToDivDireccion,
        setInputValue: setDireccionValue
    } = useInput(direccionValidacion);

    useEffect(() => {
        if(!!laboralData.direccion && !direccionUserChange){
            setDireccionValue(laboralData.direccion);
        }
    }, [laboralData.direccion, direccionUserChange, setDireccionValue]);

    // INPUT PAIS
    const paisValidacion = value => value.trim() !== "";
    const {
        value: pais,
        isValid: paisIsValid,
        isTouched: paisIsTouched,
        userChange: paisUserChange,
        divInput: divPais,
        valueChangeHandler: paisChangeHanlder,
        inputBlurHandler: paisBlurHandler,
        resetInput: resetInputPais,
        scrollToDiv: scrollToDivPais,
        setInputValue: setPaisValue
    } = useInput(paisValidacion);

    useEffect(() => {
        if(!!laboralData.pais && !paisUserChange){
            setPaisValue(laboralData.pais);
        }
    }, [laboralData.pais, paisUserChange, setPaisValue]);

    // INPUT EXPERIENCIA
    const experienciaValidacion = value =>  value.trim() !== "" && 
                                            Number.isInteger(+value) && 
                                            parseInt(+value)>=0 && 
                                            parseInt(+value)<=99;
    const {
        value: experiencia,
        isValid: experienciaIsValid,
        isTouched: experienciaIsTouched,
        userChange: experienciaUserChange,
        divInput: divExperiencia,
        valueChangeHandler: experienciaChangeHanlder,
        inputBlurHandler: experienciaBlurHandler,
        resetInput: resetInputExperiencia,
        scrollToDiv: scrollToDivExperiencia,
        setInputValue: setExperienciaValue
    } = useInput(experienciaValidacion);

    useEffect(() => {
        if(!!laboralData.experiencia && !experienciaUserChange){
            setExperienciaValue(laboralData.experiencia);
        }
    }, [laboralData.experiencia, experienciaUserChange, setExperienciaValue]);

    // INPUT CARGO
    const cargoValidacion = value => value.trim() !== "";
    const {
        value: cargo,
        isValid: cargoIsValid,
        isTouched: cargoIsTouched,
        userChange: cargoUserChange,
        divInput: divCargo,
        valueChangeHandler: cargoChangeHanlder,
        inputBlurHandler: cargoBlurHandler,
        resetInput: resetInputCargo,
        scrollToDiv: scrollToDivCargo,
        setInputValue: setCargoValue
    } = useInput(cargoValidacion);

    useEffect(() => {
        if(!!laboralData.cargo && !cargoUserChange){
            setCargoValue(laboralData.cargo);
        }
    }, [laboralData.cargo, cargoUserChange, setCargoValue]);

    // INPUT REFERENCIA LABORAL
    const referenciaValidacion = value => value.trim() !== "";
    const {
        value: referencia,
        isValid: referenciaIsValid,
        isTouched: referenciaIsTouched,
        userChange: referenciaUserChange,
        divInput: divReferencia,
        valueChangeHandler: referenciaChangeHanlder,
        inputBlurHandler: referenciaBlurHandler,
        resetInput: resetInputReferencia,
        scrollToDiv: scrollToDivReferencia,
        setInputValue: setReferenciaValue
    } = useInput(referenciaValidacion);

    useEffect(() => {
        if(!!laboralData.referencia && !referenciaUserChange){
            setReferenciaValue(laboralData.referencia);
        }
    }, [laboralData.referencia, referenciaUserChange, setReferenciaValue]);

    // INPUT TELEFONO LABORAL DE CONTACTO
    const telefonoContactoValidacion = value => value.trim() !== "";
    const {
        value: telefonoContacto,
        isValid: telefonoContactoIsValid,
        isTouched: telefonoContactoIsTouched,
        userChange: telefonoContactoUserChange,
        divInput: divTelefonoContacto,
        valueChangeHandler: telefonoContactoChangeHanlder,
        inputBlurHandler: telefonoContactoBlurHandler,
        resetInput: resetInputTelefonoContacto,
        scrollToDiv: scrollToDivTelefonoContacto,
        setInputValue: setTelContactoValue
    } = useInput(telefonoContactoValidacion);

    useEffect(() => {
        if(!!laboralData.telefonoContacto && !telefonoContactoUserChange){
            setTelContactoValue(laboralData.telefonoContacto);
        }
    }, [laboralData.telefonoContacto, telefonoContactoUserChange, setTelContactoValue]);

    // INPUT CORREO LABORAL DE CONTACTO
    const correoContactoValidacion = value => {
        const emailRE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRE.test(value);
    };
    const {
        value: correoContacto,
        isValid: correoContactoIsValid,
        isTouched: correoContactoIsTouched,
        userChange: correoContactoUserChange,
        divInput: divCorreoContacto,
        valueChangeHandler: correoContactoChangeHanlder,
        inputBlurHandler: correoContactoBlurHandler,
        resetInput: resetInputCorreoContacto,
        scrollToDiv: scrollToDivCorreoContacto,
        setInputValue: setCorreoValue
    } = useInput(correoContactoValidacion);

    useEffect(() => {
        if(!!laboralData.correoContacto && !correoContactoUserChange){
            setCorreoValue(laboralData.correoContacto);
        }
    }, [laboralData.correoContacto, correoContactoUserChange, setCorreoValue]);

    // INPUT SECTOR
    const sectorValidacion = value => value.trim() !== "";
    const {
        value: sector,
        isValid: sectorIsValid,
        isTouched: sectorIsTouched,
        userChange: sectorUserChange,
        divInput: divSector,
        valueChangeHandler: sectorChangeHanlder,
        inputBlurHandler: sectorBlurHandler,
        resetInput: resetInputSector,
        scrollToDiv: scrollToDivSector,
        setInputValue: setSectorValue
    } = useInput(sectorValidacion);

    useEffect(() => {
        if(!!laboralData.sector && !sectorUserChange){
            setSectorValue(laboralData.sector);
        }
    }, [laboralData.sector, sectorUserChange, setSectorValue]);

    // INPUT LOGROS PROFESIONALES (ARCHIVO)
    const [nombreFile, setNombreFile] = useState("");
    const {
        value: logrosFile,
        fileName: logrosFileName,
        isValid: logrosFileIsValid,
        divInput: divLogros,
        valueChangeHandler: logrosFileChangeHanlder,
        inputBlurHandler: logrosFileBlurHandler
    } = useFileInput(nombreFile, "application/pdf");

    useEffect(() => {
        setNombreFile(!!laboralData.logrosFile ? laboralData.logrosFile : nombreFile);
    }, [laboralData.logrosFile, nombreFile, setNombreFile]);

    // INPUT LOGROS PROFESIONALES (TEXTO)
    const logrosTextoValidacion = value => value.trim() !== "";
    const {
        value: logrosTexto,
        userChange: logroTextoUserChange,
        valueChangeHandler: logrosTextoChangeHanlder,
        inputBlurHandler: logrosTextoBlurHandler,
        setInputValue: setLogroTextValue
    } = useInput(logrosTextoValidacion);

    useEffect(() => {
        if(!!laboralData.logrosTexto && !logroTextoUserChange){
            setLogroTextValue(laboralData.logrosTexto);
        }
    }, [laboralData.logrosTexto, logroTextoUserChange, setLogroTextValue]);

    // INPUT TRABAJA
    const divTrabaja = useRef();
    const [trabaja, setTrabaja] = useState('');
    const [trabajaIsTouched, setTrabajaIsTouched] = useState(false);
    const trabajaIsValid = trabaja === "Y" || trabaja === "N";

    const handleEditar = () => {
        setBlock(!block);
    }

    const trabajaChangeHanlder = (event) => {
        setTrabaja(event.target.value);

        if(event.target.value === "N"){
            resetInputEmpresa();
            resetInputDireccion();
            resetInputPais();
            resetInputExperiencia();
            resetInputCargo();
            resetInputReferencia();
            resetInputTelefonoContacto();
            resetInputCorreoContacto();
            resetInputSector();
        }
    }

    const trabajaBlurHandler = () => {
        setTrabajaIsTouched(true);
    }

    const headerOffset = 56;
    const scrollToDivTrabaja = () => {
        let pos = divTrabaja.current.getBoundingClientRect().top;
        let offset = pos + window.pageYOffset - headerOffset - parseInt(window.innerHeight/10);

        window.scrollTo({
            top: offset,
            behavior: "smooth"
        });
    }

    useEffect(() => {
        setTrabaja ((!!laboralData && "trabaja" in laboralData && trabaja === "") ? laboralData.trabaja : trabaja)
        if(trabaja === "N"){
            resetInputEmpresa();
            resetInputDireccion();
            resetInputPais();
            resetInputExperiencia();
            resetInputCargo();
            resetInputReferencia();
            resetInputTelefonoContacto();
            resetInputCorreoContacto();
            resetInputSector(); 
        }
    }, [laboralData, trabaja, setTrabaja, 
        resetInputEmpresa,
        resetInputDireccion,
        resetInputPais,
        resetInputExperiencia,
        resetInputCargo,
        resetInputReferencia,
        resetInputTelefonoContacto,
        resetInputCorreoContacto,
        resetInputSector
    ]); 

    useEffect(() => {
        let flag = !!laboralData.trabaja && laboralData.trabaja !== ""
        if(flag){
            setBlock(true);
            setIsUpdate(true);
        }
    }, [laboralData]);

    // ------------------------------------------------------------------------
    // ------------------------------------------------------------------------

    let trabajaActualmente = trabajaIsValid && trabaja === "Y";
    let formIsValid = false;

    if( trabajaIsValid ){

        if( trabaja === "Y" ){

            if( empresaIsValid && 
                direccionIsValid && 
                paisIsValid && 
                experienciaIsValid &&
                cargoIsValid &&
                referenciaIsValid &&
                telefonoContactoIsValid &&
                correoContactoIsValid &&
                sectorIsValid ){
                formIsValid = true;
            }

        } else if( trabaja === "N" ){
            formIsValid = true;
        }
    }

    const [isUpdate, setIsUpdate] = useState(false);

    const formSubmitHanlder = async(event) => {
        event.preventDefault();

        // Validacion visual de inputs
        trabajaBlurHandler();
        
        if( trabaja === "Y" ){
            empresaBlurHandler();
            direccionBlurHandler(); 
            paisBlurHandler();
            experienciaBlurHandler();
            cargoBlurHandler();
            referenciaBlurHandler();
            telefonoContactoBlurHandler();
            correoContactoBlurHandler();
            sectorBlurHandler();
        }

        if(!formIsValid){
            setAppValues(
                prev => {
                    let perfil = prev.experienciaLaboral ? prev.perfil-25 : prev.perfil;
                    return { ...prev, experienciaLaboral: false, perfil };
                }
            );

            if(!trabajaIsValid){
                scrollToDivTrabaja();
                return;
            }

            if( trabaja === "Y" ){
                if(!empresaIsValid){
                    scrollToDivEmpresa();
                    return;
                }
    
                if(!direccionIsValid){
                    scrollToDivDireccion();
                    return;
                }
    
                if(!paisIsValid){
                    scrollToDivPais();
                    return;
                }
    
                if(!experienciaIsValid){
                    scrollToDivExperiencia();
                    return;
                }
    
                if(!cargoIsValid){
                    scrollToDivCargo();
                    return;
                }
    
                if(!referenciaIsValid){
                    scrollToDivReferencia();
                    return;
                }
    
                if(!telefonoContactoIsValid){
                    scrollToDivTelefonoContacto();
                    return;
                }
    
                if(!correoContactoIsValid){
                    scrollToDivCorreoContacto();
                    return;
                }
    
                if(!sectorIsValid){
                    scrollToDivSector();
                    return;
                }

            }

            return;
        }

        

        const form_data = new FormData();
        form_data.append('idToken', authContext.token);
        form_data.append('trabaja', trabaja);
        form_data.append('empresa', empresa);
        form_data.append('direccion', direccion);
        form_data.append('pais', pais === "" ? 'NULL': pais);
        form_data.append('experiencia', experiencia  === "" ? 0 : experiencia);
        form_data.append('cargo', cargo);
        form_data.append('referencia', referencia);
        form_data.append('telefonoContacto', telefonoContacto);
        form_data.append('correoContacto', correoContacto);
        form_data.append('sector', sector);
        form_data.append('logrosFile', logrosFile[0] === undefined ? nombreFile : logrosFile[0]);
        form_data.append('logrosTexto', logrosTexto);

        if(isUpdate)
        {
            form_data.append('updateExperienciaLaboral', 1);
        }else {
            form_data.append('saveExperienciaLaboral', 1);
        }

        axios.post(process.env.REACT_APP_API_URL, form_data)
            .then(res => {
                setAppValues(
                    prev => {
                        let perfil = prev.experienciaLaboral ? prev.perfil : prev.perfil+25;
                        return { ...prev, experienciaLaboral: true, perfil };
                    }
                );
                setBlock(true);
                setIsUpdate(true);
                props.onCompletado('experiencia-laboral');
            })
            .catch((error) => {
                console.log(error)
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema, intentelo más tarde',
                    showConfirmButton: false,
                    timer: 3500
                });
            });
    }


    return (
        <>
        {
            error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body d-flex align-items-center justify-content-center" style={{ height: '565px' }}>
                            <div className="text-center" style={{ color: 'rgba(0,0,0,.3)', fontSize: '2.5rem' }} >
                                <span style={{ fontSize: "7rem" }}><MdErrorOutline/></span>
                                <br />
                                ¡Error!
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        }
        { 
            !error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body">
                            <form className="row my-4" onSubmit={formSubmitHanlder}>

                                {/* POSEE TRABAJO */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divTrabaja}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>¿Trabaja actualmente?</label>
                                    <div className="form-check">
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${trabajaIsTouched ? ((trabajaIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="experiencia"
                                            value="Y"
                                            checked={trabaja === "Y"}
                                            onChange={trabajaChangeHanlder}
                                            onBlur={trabajaBlurHandler} 
                                            disabled={block}
                                        />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>Sí</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${trabajaIsTouched ? ((trabajaIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="experiencia"
                                            value="N"
                                            checked={trabaja === "N"}
                                            onChange={trabajaChangeHanlder}
                                            onBlur={trabajaBlurHandler} 
                                            disabled={block}
                                            />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>No</label>
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Debe seleccionar una opción
                                        </div>
                                    </div>
                                </div>

                                {/* EMPRESA */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divEmpresa}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Empresa</label>
                                    <input 
                                        type="text" 
                                        name="empresa"
                                        className={`form-control form-control-sm shadow-sm ${empresaIsTouched ? ((empresaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        placeholder="Nombre de la empresa"
                                        value={empresa}
                                        onChange={empresaChangeHanlder}
                                        onBlur={empresaBlurHandler} 
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* DIRECCION */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divDireccion}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Dirección</label>
                                    <input 
                                        type="text" 
                                        name="direccion"
                                        className={`form-control form-control-sm shadow-sm ${direccionIsTouched ? ((direccionIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        value={direccion}
                                        onChange={direccionChangeHanlder}
                                        onBlur={direccionBlurHandler}
                                        placeholder="Dirección de la empresa" 
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* PAIS */}
                                <div className="col-md-6 offset-md-1 mb-3" ref={divPais}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='pais' >País</label>
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${paisIsTouched ? ((paisIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='pais' 
                                        value={pais} 
                                        onChange={paisChangeHanlder}
                                        onBlur={paisBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar país</option>
                                        {paises.map(pais => (
                                            <option key={pais.PAIS} value={pais.PAIS}>{pais.NOMBRE}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* AÑOS DE EXPERIENCIA LABORAL */}
                                <div className="col-md-6 offset-md-1 mb-3" ref={divExperiencia}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Años de experiencia laboral</label>
                                    <div className="col-md-8">
                                        <input 
                                            type="number" 
                                            name="experiencia" 
                                            min={0} 
                                            max={99}
                                            value={experiencia}
                                            onChange={experienciaChangeHanlder}
                                            onBlur={experienciaBlurHandler}
                                            className={`form-control form-control-sm shadow-sm ${experienciaIsTouched ? ((experienciaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            placeholder="Ingrese años"
                                            disabled={!trabajaActualmente || block} />
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                    </div>
                                </div>

                                {/* CARGO */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divCargo}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Cargo</label>
                                    <input 
                                        type="text" 
                                        name="cargo"
                                        value={cargo}
                                        onChange={cargoChangeHanlder}
                                        onBlur={cargoBlurHandler}
                                        className={`form-control form-control-sm shadow-sm ${cargoIsTouched ? ((cargoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        placeholder="Cargo que desempeña"
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                <hr className="col-md-10 offset-md-1 my-4 text-black-50 shadow-sm" />

                                {/* REFERENCIA LABORAL */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divReferencia}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Referencia laboral</label>
                                    <input 
                                        type="text" 
                                        name="referencia"
                                        value={referencia}
                                        onChange={referenciaChangeHanlder}
                                        onBlur={referenciaBlurHandler}
                                        className={`form-control form-control-sm shadow-sm ${referenciaIsTouched ? ((referenciaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        placeholder="Nombre de referencia laboral"
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* TELEFONO LABORAL DE CONTACTO */}
                                <div className="col-md-7 offset-md-1 mb-3" ref={divTelefonoContacto}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='telefonoPersonal'>Teléfono laboral de contacto</label>
                                    <div className="col-md-8">
                                        <input 
                                            type="text" 
                                            className={`form-control form-control-sm shadow-sm ${telefonoContactoIsTouched ? ((telefonoContactoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            name='telefonoLaboralContacto' 
                                            value={telefonoContacto}
                                            onChange={telefonoContactoChangeHanlder}
                                            onBlur={telefonoContactoBlurHandler}
                                            placeholder="Ingrese teléfono"
                                            autoComplete='off'
                                            disabled={!trabajaActualmente || block} />
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                    </div>
                                </div>

                                {/* CORREO LABORAL DE CONTACTO */}
                                <div className="col-md-8 offset-md-1 mb-3" ref={divCorreoContacto}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Correo laboral de contacto</label>
                                    <input 
                                        type="email" 
                                        className={`form-control form-control-sm shadow-sm ${correoContactoIsTouched ? ((correoContactoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='correoLaboralContacto'
                                        value={correoContacto}
                                        onChange={correoContactoChangeHanlder}
                                        onBlur={correoContactoBlurHandler}
                                        placeholder="ejemplo@empresa.com"
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Debe ingresar un correo válido
                                    </div>
                                </div>

                                {/* SECTOR */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divSector}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Sector</label>
                                    <div className="form-check">
                                        <input 
                                            type="radio" 
                                            className={`form-check-input shadow-sm ${sectorIsTouched ? ((sectorIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="sector"
                                            value={"publico"}
                                            checked={sector === "publico"}
                                            onChange={sectorChangeHanlder}
                                            onBlur={sectorBlurHandler}
                                            disabled={!trabajaActualmente || block} />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>Público</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${sectorIsTouched ? ((sectorIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="sector"
                                            value={"privado"}
                                            checked={sector === "privado"}
                                            onChange={sectorChangeHanlder}
                                            onBlur={sectorBlurHandler}
                                            disabled={!trabajaActualmente || block} />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>Privado</label>
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Debe seleccionar una opción
                                        </div>
                                    </div>
                                </div>

                                {/* LOGROS PROFESIONALES */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divLogros}>

                                    {/* FILE */}
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Logros profesionales</label>
                                    <input
                                        type="file"
                                        className={`form-control form-control-sm shadow-sm`}
                                        name="logros"
                                        onChange={logrosFileChangeHanlder}
                                        onBlur={logrosFileBlurHandler}
                                        disabled={block}
                                    />
                                    {logrosFileIsValid && <div className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {logrosFileName}
                                    </div>}

                                    {/* TEXTAREA */}
                                    <div className="form-floating mt-1">
                                        <textarea 
                                            className={`form-control form-control-sm shadow-sm`}
                                            placeholder="Leave a comment here" 
                                            name="logrosTexto" 
                                            style={{height: '100px'}}
                                            value={logrosTexto}
                                            onChange={logrosTextoChangeHanlder}
                                            onBlur={logrosTextoBlurHandler}
                                            readOnly={block}></textarea>
                                        <label htmlFor="logrosTexto" className="text-black-50">Escriba sus logros profesionales</label>
                                        <div className={`form-text fst-italic`} style={{userSelect: 'none'}}>
                                            Adjuntar documento o escribir logros profesionales en el recuadro (5 líneas)
                                        </div>
                                    </div>
                                </div>
                                
                                {/* EDITAR/GUARDAR */}
                                <div className="col-md-10 offset-md-1 mt-3" style={{ textAlign: 'right' }}>
                                    <div className="btn-group">
                                        <button 
                                            className={`btn ${block ? 'btn-dark':'btn-outline-dark disabled'}`}
                                            type="button"
                                            onClick={() => handleEditar()}
                                            disabled={!block} >
                                            <MdEdit /> Editar
                                        </button>
                                        <button 
                                            className={`btn ${block ? 'btn-outline-danger disabled':'btn-danger'}`}
                                            type="submit"
                                            disabled={block} >
                                            <MdSave /> Guardar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Card>
                </div>
            </div>
        }
        </>
    )
}

export default ExperienciaLaboral